// Checkout page and form copy. Toasts and validation messages live in `feedback.ts`.
export const checkoutContent = {
  // Page
  pageDescription: 'Review and complete your order.',
  emptyCartHeading: 'Your Cart is Empty',
  emptyCartMessage:
    'You have no items in your cart. Please add items to your cart before proceeding to checkout.',
  continueToPaymentLabel: 'Continue to Payment',
  checkoutLabel: 'Checkout',
  processingCheckoutHeading: 'Processing Your Checkout',

  // Paid or held elsewhere. One sentence around the help link.
  paidOrderIncompleteLead:
    "We've received payment for this order, but it isn't complete yet. Please",
  paidOrderIncompleteLinkLabel: 'contact customer service',
  paidOrderIncompleteTail: 'for help with it.',
  paymentHeldElsewhereMessage: 'A payment for this cart is in progress in another tab.',

  // Payment hold modal, shown on any page while another tab or device pays
  paymentHoldTitle: 'Payment in progress',
  paymentHoldMessage:
    'A payment is in progress for this cart. Changes are paused until it finishes.',
  checkAgainLabel: 'Check again',

  // Screen-reader status for the Stripe forms
  paymentFormLoadingStatus: 'Loading the payment form. Please wait.',
  paymentFormReadyStatus: 'The payment form is ready.',
  paymentFormFailedStatus: 'The payment form could not be loaded. Refresh the page to try again.',
  addressFormLoadingStatus: 'Loading the address form. Please wait.',
  addressFormReadyStatus: 'The address form is ready.',
  addressFormFailedStatus: 'The address form could not be loaded. Refresh the page to try again.',

  // Customer info (also the payment step's back-button label)
  customerInfoHeading: 'Customer Info',
  emailLabel: 'Email',
  phoneLabel: 'Phone',
  relationshipLabel: 'Your Relationship To Student',
  relationshipStudentLabel: 'I am the student',
  relationshipMotherLabel: 'Mother',
  relationshipFatherLabel: 'Father',
  relationshipOtherLabel: 'Other',

  // Addresses
  shippingAddressHeading: 'Shipping Address',
  shippingRestrictionNote: 'We currently only ship within the 50 United States.',
  billingAddressHeading: 'Billing Address',
  addressLine1Label: 'Address Line 1',
  addressLine2Label: 'Address Line 2',
  cityLabel: 'City',
  stateLabel: 'State',
  zipLabel: 'ZIP',

  // Promo codes
  discountCodeLabel: 'Discount Code',
  promoCodeInvalidTemplate: '##PromoCode## is Invalid',
  couponCodeAppliedOne: 'Coupon Code Applied',
  couponCodeAppliedOther: 'Coupon Codes Applied',

  // Terms
  viewFullTermsLabel: 'View Full Terms',
  termsAcknowledgement:
    'By checking this box, I acknowledge that I have viewed and agree to the Terms & Conditions'
}
